var _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftBoldArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.018,
    height: 18,
    viewBox: "0 0 20.018 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "10.018 18 10.018 13 20.018 13 20.018 5 10.018 5 10.018 0 0 8.939 10.018 18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBoldArrow);
export default __webpack_public_path__ + "static/media/Left_Bold_Arrow.df7cea18ced4c4473809309a03899167.svg";
export { ForwardRef as ReactComponent };